import Http from "../api/http";

export default class Weixin extends Http {
  constructor() {
    super();
  }
  /***********微信管理***************/
  /**
   * 微信网页授权
   * @param {string} code -  code
   */
  weixin_bindWeixinWebLogin() {
    return super.post("weixin/weixin/bindWeixinWebLogin", ...arguments);
  }

  /**
   * 公众号登录
   */
  weixin_weChatCodeLogin() {
    return super.post("weixin/weChatCodeLogin", ...arguments);
  }
}
